DNDLocationPicker = null
tmout = setInterval ()=>
  if $(document).find("#DND--location-picker").is("div")
    clearTimeout(tmout)
    DNDLocationPicker = new Vue(
      el: "#DND--location-picker"
      data: {
        locationList: []
        locationPathList: []
        defaultLocationList: []
        mode: 'defaultLocation'
        loadMode: false
        currentSearch: ""
        currentSearchalt: ""
        currentCity: ""
      }
      computed: {
      }
      methods: {
        clearTF: ()->
          this.loadMode = false
          this.mode = "defaultLocation"
          this.currentSearch = ""
          this.currentSearchalt = ""
          $(document).find('.geo-pop-up-search>input').val("")

        addedTitle: (pathList)->
          returnAdded = ""

          pathList.forEach((el) =>
            pathItem = this.locationPathList.find((elm) =>
              return elm.id == el && elm.id != 1
            )

            if pathItem
              returnAdded += ", " + pathItem.title
          )

          return returnAdded

        getLocationList: ()->
          returnData = []
          if this.mode == "defaultLocation"
            returnData = this.defaultLocationList
          else
            returnData = this.locationList.filter((el) =>
              return el.typeID == "5" || el.typeID == "6"
            ).filter((el, ind) =>
              return ind < 10
            ).map((el) =>
              return {
                id: el.id,
                code: el.code,
                title: el.title,
                typeID: el.typeID,
                sub: this.addedTitle(el.path)
              }
            )

          return returnData

        altWayLoadDataByOpenForm: ()->
          if this.defaultLocationList.length == 0
            this.getDefaultLocation()

        getDefaultLocation: ()->
          $.ajax {
            type: "POST",
            url: "/ajax/getDefaultLocation.php",
            data: {},
            success: (data) =>
              console.log data
              if data.items
                this.defaultLocationList = data.items.map((el)->
                  return {
                    id: el.id,
                    code: el.code,
                    title: el.name,
                    typeID: "5",
                  }
                )
                this.getCurrentLocation()
          }

        getLocationByPhraze: (phrase)->
          this.currentSearchalt = phrase
          if phrase.length >= 3
            if this.currentSearch !=phrase
              this.currentSearch = phrase
              this.loadMode = true
              dataRequest = {}
              dataRequest['select[1]'] = 'CODE'
              dataRequest['select[2]'] = 'TYPE_ID'
              dataRequest['select[VALUE]'] = 'ID'
              dataRequest['select[DISPLAY]'] = 'NAME.NAME'
              dataRequest['additionals[1]'] = 'PATH'
              dataRequest['filter[=PHRASE]'] = phrase
              dataRequest['filter[=NAME.LANGUAGE_ID]'] = 'ru'
              dataRequest['version'] = 2
              dataRequest['PAGE_SIZE'] = 10
              dataRequest['PAGE'] = 0
              console.log dataRequest

              $.ajax {
                type: "POST",
                url: "/bitrix/components/dnd/sale.location.selector.search/get.php",
                data: dataRequest,
                success: (data) =>
                  console.log "success get"
                error: (data)=>
                  console.log data
                complete: (data)=>
                  if this.currentSearch == dataRequest['filter[=PHRASE]']
                    this.loadMode = false
                    if data.responseText
                      data = JSON.parse(data.responseText)
                      if data.data
                        if data.data.ITEMS
                          this.mode = "responseLocation"
                          this.locationList = data.data.ITEMS.map((el)->
                            return {
                              id: el.VALUE,
                              code: el.CODE,
                              title: el.DISPLAY,
                              typeID: el.TYPE_ID,
                              path: el.PATH
                            }
                          )

                          this.locationPathList = Object.values(data.data.ETC.PATH_ITEMS).map((el)->
                            return {
                              id: el.VALUE,
                              code: el.CODE,
                              title: el.DISPLAY,
                              typeID: el.TYPE_ID,
                            }
                          )
              }
          else
            # if phrase.length == 0
            this.currentSearch = ""
            this.loadMode = false
            this.mode = "defaultLocation"

        changeCurentLocation: (itemID, title, code)->
          this.currentCity = title
          $(document).find('.geolocation-btn>.text').html(title)
          $(document).find('#mobile-location-btn-block-header .text').html(title)
          this.loadMode = false
          this.mode = "defaultLocation"
          this.currentSearch = ""
          this.currentSearchalt = ""
          $(document).find('.geo-pop-up-search>input').val("")
          changeOpenStateGeo()
          console.log itemID, code, title
          # customLocationInOrder(itemID, code, title)
          redirectState = this.checkIfNeedReload(itemID)
          $.ajax {
            type: "POST",
            url: "/ajax/setLocation.php",
            data: {cityID: itemID},
            success: (data) =>
              if data.cityData
                console.log data
                customLocationInOrder(data.cityData.id, data.cityData.code, data.cityData.name)
                this.currentCity = data.cityData.name
                if redirectState
                  location.href = location.href

          }

        checkIfNeedReload: (id)->
          returnState = false

          if location.pathname != '/personal/order/make/indexnew.php' && location.pathname != '/personal/order/make/'
            CityForRedirect = JSON.parse($(document).find("#fix-compozit-kala").attr("data-city-for-redirect"))
            CurrentCityID = $(document).find("#fix-compozit-kala").attr("data-current-city-id")

            curentCityHasPrice = !!CityForRedirect.find((el)->
              parseInt(el.id) == parseInt(CurrentCityID)
            )
            nextCityHasPrice = !!CityForRedirect.find((el)->
              parseInt(el.id) == parseInt(id)
            )

            if nextCityHasPrice && parseInt(id) != parseInt(CurrentCityID)
              returnState = true
            else if curentCityHasPrice && parseInt(id) != parseInt(CurrentCityID)
              returnState = true

          return returnState

        getCurrentLocation: ()->
          $.ajax {
            type: "POST",
            url: "/ajax/setLocation.php",
            data: {},
            success: (data) =>
              if data.cityData
                this.currentCity = data.cityData.name
          }

        beforeEnter: (el)->
          el.style.opacity = 0
        enter: (el, done)->
          setTimeout(()=>
            $(el).animate({ opacity: 1 }, (150), ()=>
              done()
            )
          , (100*el.dataset.index))
        leave: (el, done)->
          el.style.opacity = 0
          done()

      }
      mounted: ()->
        if $(document).find(".geo-pop-up").hasClass("gpu--open")
          this.getDefaultLocation()
        # setTimeout( () =>
        #   this.getDefaultLocation()
        # , 500)
        # this.getCurrentLocation()
    )
,1500



customLocationInOrder = (id, code, title) ->
  console.log id, code, title
  if $(document).find(".custom-location-picked").is("div")
    $(document).find(".custom-location-picked").find('[name="ORDER_PROP_13"]').val(code)
    $(document).find(".custom-location-picked").find('[name="RECENT_DELIVERY_VALUE"]').val(code)
    $(document).find(".custom-location-picked").find('.geolocation-btn>.text').html(title)
    $(document).find('.location-btn-block-header>.geolocation-btn').attr("data-loc-code", code)
    $(document).find('.location-btn-block-header>.geolocation-btn').attr("data-loc-name", title)
    $.ajax({
        type: "GET",
        url: "/ajax/orderCheckAvailable.php",
        success: (data)->
          $("body").append(data)
    })
    setTimeout(()->
      BX.Sale.OrderAjaxComponent.sendRequest()
    , 600)
